/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @oncall relay
 */

'use strict';

var areEqual = require("fbjs/lib/areEqual");
var _require = require('react'),
  useState = _require.useState;

/**
 * Memoizes the passed in `variables` object based on `areEqual` equality.
 * This is useful when a `variables` object is used as a value in a depencency
 * array as it might often be constructed during render.
 */
function useMemoVariables(variables) {
  var _useState = useState(variables),
    mirroredVariables = _useState[0],
    setMirroredVariables = _useState[1];
  if (areEqual(variables, mirroredVariables)) {
    return mirroredVariables;
  } else {
    setMirroredVariables(variables);
    return variables;
  }
}
module.exports = useMemoVariables;